import { render, staticRenderFns } from "./PageBatchMarket.vue?vue&type=template&id=6e4d5f3e&scoped=true"
import script from "./PageBatchMarket.vue?vue&type=script&lang=js"
export * from "./PageBatchMarket.vue?vue&type=script&lang=js"
import style0 from "./PageBatchMarket.vue?vue&type=style&index=0&id=6e4d5f3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4d5f3e",
  null
  
)

export default component.exports